/**
 * Application Version
 * Auto-incremented on each deployment
 */

export const APP_VERSION = '1.0.450';
export const BUILD_DATE = '2026-10-20T17:49:49.886Z';
export const BUILD_ENV = import.meta.env.MODE || 'production';

// Version info for display
export const getVersionInfo = () => ({
  version: APP_VERSION,
  buildDate: BUILD_DATE,
  environment: BUILD_ENV,
  displayText: `v${APP_VERSION}`
});
